import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    padding: [theme.spacing(3), 0],
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      padding: [0, 0, theme.spacing(4)],
    },
  },
  button: {
    borderColor: theme.palette.colors.teal,
    [theme.breakpoints.up('mobile')]: {
      width: 194,
    },
  },
  avatar: {
    width: 110,
    height: 110,
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('mobile')]: {
      width: 96,
      height: 96,
      marginRight: theme.spacing(4),
    },
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 10,
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/Avatar/useStyles.js